<template>
  <b-card>
    <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click.stop="openModal(true)"
    >
      <feather-icon icon="PlusIcon" />
      Adicionar
    </b-button>
    <custom-g-table
      v-if="data.length > 0"
      :displayLoading="false"
      :fields="fields"
      :items="data"
      :hasEditButton="true"
      :hasDeleteButton="false"
      :totalRows="data.length"
      :limit="50"
      @onEdit="onEdit"
    />
    <b-modal
        ref="edit-client-system-modal"
        modal-class="modal-primary"
        title="Editar Sistema"
        ok-title="Adicionar"
        centered
        no-close-on-backdrop
        size="xl"
      >
        <div class="d-block">
          <user-client-register-system-edit
            ref="user-client-register-system-edit"
            :clientId="clientId"
            @close="onCloseModal"
            @submit="onSubmit"
          ></user-client-register-system-edit>
        </div>
      </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton
} from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import UserClientRegisterSystemEdit from "./UserClientRegisterSystemEdit.vue";

export default {
  data() {
    return {
      dataID: null,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "origin", label: "Origem", type: "object" },
        { field: "origin", label: "Código Origem", type: "object", object_field: "code" },
        { field: "logicalNumber", label: "Numero logico", type: "object" },
        { field: "profile", label: "Perfil" },

        { field: "filters", label: "Direitos" },
        { field: "logical_user", label: "Usuario Lógico" },
        { field: "service", label: "service" },
        
        
        { field: "siga_login_inicio", label: "siga_login_inicio" },
        { field: "siga_login_termino", label: "siga_login_termino" },
        { field: "siga_login_atualizacao", label: "siga_login_atualizacao" },
        { field: "siga_posicao", label: "siga_posicao" },

        { field: "dt_first_access", label: "Primeiro Acesso", type: "custom_date" },
        { field: "dt_last_access", label: "Ultimo acesso", type: "custom_date" },
        
        { field: "cma_pwd", label: "cma_pwd" },
        { field: "customer_id", label: "customer_id" },
        { field: "available_questions", label: "Perguntas disponíveis" },
        { field: "push_notification", label: "Notificação push", type: "array" },
        { field: "sendmail_content", label: "Conteúdo sendmail", type: "array" },
        { field: "country", label: "País", type: "object" },
        { field: "wdma_route", label: "Wdma Route", type: "object" },

        { field: "device_id", label: "device_id" },
        { field: "active", label: "Habilitado", type: "boolean" },
         { field: "blocked", label: "Bloqueado", type: "boolean" },
        { field: "blocked_reason", label: "Bloqueado Motivo" },
        { field: "token", label: "token" },
        { field: "url_token", label: "url_token" },
      ],
      data: []
    };
  },
  props: {
    clientId: {
      type: String,
      default: ""
    }
  },
  created() {},
  computed: {},
  watch: {},
  methods: {
    onEdit(val) {
      this.openModal(false);
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs['user-client-register-system-edit'].form = JSON.parse(JSON.stringify(val));
        });
      }, 500);
    },
    openModal(newRegister) {
      this.$refs['edit-client-system-modal'].show();
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs['user-client-register-system-edit'].newRegister = newRegister;
        });
      }, 500);
    },
    onCloseModal() {
      this.$refs['edit-client-system-modal'].hide();
    },
    onSubmit(val) {
      this.$emit('submit-system-edit', val);
      this.onCloseModal();
    }
  },
  components: {
    BCard,
    BButton,
    CustomGTable,
    UserClientRegisterSystemEdit
  },
};
</script>

<style lang="scss">
</style>